// Barrel d'export des sections utilisées par le site LDC.
// Version allégée (pas de registry builder, pas de meta).

import type { SectionConfig } from '@/types/site'

export interface SectionComponentProps {
  config: SectionConfig
  isEditing?: boolean
}

export { HeroSection } from './hero/HeroSection'
export { CTASection } from './cta/CTASection'
export { FeaturesSection } from './features/FeaturesSection'
export { PricingSection } from './pricing/PricingSection'
export { FAQSection } from './faq/FAQSection'
export { StepsSection } from './steps/StepsSection'
export { SliderSection } from './slider/SliderSection'
export { FormSection } from './form/FormSection'
export { EmbedSection } from './embed/EmbedSection'
export { SiteHeaderSection } from './header/SiteHeaderSection'
export { SiteFooterSection } from './footer/SiteFooterSection'

// Type minimal pour les exports `*Meta` des sections (vestige builder, on ne l'utilise pas pour le rendu)
export interface SectionMeta {
  type: string
  label: string
  icon: string
  variants: string[]
  defaultVariant: string
  defaultContent: Record<string, unknown>
}
